import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import FAQAccordion from "../components/FAQAccordion";
import CTASection from "../components/CTASection";
import { Reveal } from "../components/Reveal";
import { faqs, faqCategories } from "../data/faqs";

export default function FaqPage() {
  return (
    <>
      <SEO
        title="Salon FAQ | Glow & Blow Banjara Hills"
        description="Common questions about appointments, services, pricing, location and opening hours at Glow & Blow Unisex Salon, Banjara Hills."
      />
      <PageHero
        eyebrow="FAQ"
        titleLines={[
          <>Questions,</>,
          <>
            <em className="italic text-champagne">Answered</em>
          </>,
        ]}
        copy="Everything you might want to know before your visit — appointments, services, pricing, hours and finding us."
      />

      <section className="pb-24 md:pb-32" data-testid="faq-page">
        <div className="container-x space-y-16">
          {faqCategories.map((cat, ci) => {
            const items = faqs.filter((f) => f.category === cat);
            if (!items.length) return null;
            return (
              <Reveal key={cat}>
                <div className="grid gap-6 lg:grid-cols-12 lg:gap-10">
                  <div className="lg:col-span-4">
                    <div className="flex items-center gap-4">
                      <span className="font-display text-base italic text-champagne">
                        {String(ci + 1).padStart(2, "0")}
                      </span>
                      <h2 className="font-display text-2xl font-medium text-ink md:text-3xl">
                        {cat}
                      </h2>
                    </div>
                  </div>
                  <div className="lg:col-span-8">
                    <FAQAccordion items={items} idPrefix={`faq-${ci}`} />
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <CTASection />
    </>
  );
}
